import cn from "classnames";

import React from "react";
import { useLocation } from "react-router-dom";

import { Chip, ChipProps } from "@mui/material";

import useThemeData from "@/hooks/useThemeData";
import { Nav } from "@/typings";

interface ToolBarNavBtnProps extends ChipProps {
  data: Nav;
  forceActive?: boolean;
}

const ToolBarNavBtn = ({ data, forceActive, ...restProps }: ToolBarNavBtnProps) => {
  const location = useLocation();
  const theme = useThemeData();

  const isActive = forceActive || (data.matches || []).includes(location.pathname);

  const borderColor = theme.isDarkMode ? "#3c4043" : "#609edb";
  const hoverbBorderColor = theme.isDarkMode ? "#5f6368" : "#dadce0";
  const activeBorderColor = theme.isDarkMode ? "#3c4043" : "#e8f0fe";

  const activeBgColor = theme.isDarkMode ? "#394457" : "#e8f0fe";
  const hoverBgColor = theme.isDarkMode ? "#25272e" : "#f7f9fd";

  return (
    <Chip
      label={data.name}
      variant="outlined"
      icon={data.icon}
      className={cn({
        active: isActive,
      })}
      sx={{
        height: "40px",
        minWidth: "105px",
        borderRadius: "20px",
        padding: "0 16px",
        transition: "all 0.3s",
        marginRight: "8px",
        // borderColor,
        "& .MuiChip-label": {
          padding: 0,
          fontSize: "14px",
          transition: "all 0.3s",
          // color: "#fff",
        },
        "& .MuiChip-icon": {
          marginRight: "6px",
          marginLeft: "0px",
          fontSize: "18px",
          transition: "all 0.3s",
          // color: theme.isDarkMode ? theme.palette.primary.main : "#fff",
        },
        "&:hover": {
          borderColor: hoverbBorderColor,
          backgroundColor: `${hoverBgColor} !important`,
          "& .MuiChip-label": {
            color: theme.palette.primary.main,
          },
          "& .MuiChip-icon": {
            color: theme.palette.primary.main,
          },
        },
        "&.active": {
          backgroundColor: `${activeBgColor} !important`,
          borderColor: `${activeBorderColor} !important`,
          "& .MuiChip-label": {
            color: theme.palette.primary.main,
          },
          "& .MuiChip-icon": {
            color: theme.palette.primary.main,
          },
        },
      }}
      {...restProps}
    />
  );
};

export default React.memo(ToolBarNavBtn);
